import { exponential } from './shapes/exponential';
import { lorentzToGauss } from './shapes/lorentzToGauss';
export function getFunction(shape) {
    const { kind, options } = shape;
    switch (kind) {
        case 'exponential':
            return exponential(options);
        case 'lorentzToGauss':
            return lorentzToGauss(options);
        default:
            throw Error(`Unknown distribution ${kind}`);
    }
}
//# sourceMappingURL=getFunction.js.map